<!-- {#await promise}
  <DropdownSkeleton type="inline" />
{:then data} -->
	<MultiSelect
		size="sm"
		type="inline"
		filterable
		titleText="Panel"
		selectionFeedback="top"
		selectedIds={selectedIds}
		on:select={e=>handleSelect(e)}
		items={data}
	/>
<!-- {/await} -->

<!-- <style lang="scss" global>
	/** Gray 10 theme **/
  @import "carbon-components-svelte/css/g90";
</style> -->

<script>

	export let selectedIds
	import { createEventDispatcher } from "svelte"
	import { get } from 'svelte/store'
	import auth from '../../../helpers/auth.js'	

	import { navigate } from 'svelte-routing'
 
  import { Dropdown, DropdownSkeleton, MultiSelect } from "carbon-components-svelte"

	const dispatch = createEventDispatcher()
	
	const user = get(auth)
	// const promise = loadPanels()
	let selected = []
	// let data = []
	$: data = user.panels.map( e => ({'id':e.id, 'text': e.name}) )

	const handleSelect = async (e) => {
		selected = e.detail.selectedIds
		dispatch('selected',e.detail.selectedIds)
	}

	async function loadPanels() {
		return await user.panels.map( e => ({'id':e.id, 'text': e.name}))
	}
</script>